import {
  Box,
  Button,
  Typography,
  Alert,
  CircularProgress,
} from "@mui/material";
import * as React from "react";
import StudentFormNoSend from "../../views/Students/StudentFormNoSend";
import RepresentativeFormNoSend from "../Representatives/RepresentativeFormNoSend";
import CourseSelectFormNoSend from "../Course/CourseSelectFormNoSend";
import PaymentStudentdataPublic from "./PaymentStudentdataPublic";
import {
  CourseType,
  PasswordDataType,
  PaymentsType,
  RepresentativeFormType,
  StudentFormType,
} from "../../types/entitiesModel";
import { useNavigate } from "react-router-dom";


const CreateStudentPublic: React.FC = () => {
  const navigate = useNavigate();

  const [formStateStudent, setFormStateStudent] =
    React.useState<StudentFormType>({
      name: "",
      document: "",
      email: "",
      phone: "",
      address: "",
      representative_id: 0,
      category_id: 0,
      imageString: ""
    });

  const [formStateRepresentative, setFormStateRepresentative] =
    React.useState<RepresentativeFormType>({
      name: "",
      document: "",
      relationship: "",
      phone: "",
      email: "",
    });

  const [passwordData, setPasswordData] = React.useState<PasswordDataType>({
    password: "",
    confirmPassword: "",
  });

  const [reference, setReference] = React.useState<string>("");
  const [selectionCourse, setSelectionCourse] =
    React.useState<CourseType | null>(null);
  const [selectionPaymentMethod, setSelectionPaymentMethod] =
    React.useState<PaymentsType | null>(null);
  const [repExists, setRepExists] = React.useState<boolean>(false);
  const [step, setStep] = React.useState<number>(1);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const handleChangeFormStudent = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    setFormStateStudent((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleChangeFormRepresentative = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    setFormStateRepresentative((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleNextStep = () => {
    setError(null); // Limpiamos cualquier error previo al avanzar
    if (step < 2) {
      setStep(step + 1);
    } else {
      handleSubmit();
    }
  };

  const handlePreviousStep = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  /**
   * to send data to api
   */
  const handleSubmit = async () => {
    if (
      !formStateStudent.name ||
      !formStateRepresentative.name ||
      !passwordData.password ||
      passwordData.password !== passwordData.confirmPassword ||
      !selectionCourse ||
      !selectionPaymentMethod ||
      !reference
    ) {
      setError(
        "Por favor, complete todos los campos y asegúrese de que las contraseñas coincidan."
      );
      return;
    }

    const data = {
      student: formStateStudent,
      representative: formStateRepresentative,
      passwordData,
      course: selectionCourse,
      paymentMethod: selectionPaymentMethod,
      reference,
    };

    setLoading(true);
    setError(null);

    try {
      const response = await fetch("appservice/coursestudents", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || "Hubo un problema al enviar el formulario."
        );
      }

      alert("Inscripción completada con éxito");
      setTimeout(() => {
        navigate("/admin/users");
      }, 1000);
    } catch (err: any) {
      setError(err.message || "Ocurrió un error en el servidor.");
    } finally {
      setLoading(false);
    }
  };

  // React.useEffect(()=> {
  //   console.log('La data del estudiante: ' + JSON.stringify(formStateStudent));
  // }, [formStateStudent])

  return (
    <Box>
      {step === 1 && (
        <>
          <Box sx={{ paddingLeft: 2, mb: 2 }}>
            <Typography variant="h1">Información de inscripción</Typography>
          </Box>
          <Box>
            <CourseSelectFormNoSend
              selectionCourse={selectionCourse}
              setSelectionCourse={setSelectionCourse}
            />
          </Box>
          <Box>
            <StudentFormNoSend
              formState={formStateStudent}
              handleChangeForm={handleChangeFormStudent}
              setFormStateStudent={setFormStateStudent}
              repExists={repExists}
              setRepExists={setRepExists}
              showRepresentative={false}
            />
          </Box>
          <Box>
            <RepresentativeFormNoSend
              formState={formStateRepresentative}
              handleChangeForm={handleChangeFormRepresentative}
              setFormStateStudent={setFormStateRepresentative}
              repExists={repExists}
              setRepExists={setRepExists}
              importantAddRep={true}
              addPasswordField={true}
              passwordState={passwordData}
              setPasswordData={setPasswordData}
            />
          </Box>
        </>
      )}

      {step === 2 && (
        <>
          <Box>
            <Typography variant="h1" sx={{ ml: 2, mb: 4 }}>
              Información de Pago
            </Typography>
            <PaymentStudentdataPublic
              selectionPaymentMethod={selectionPaymentMethod}
              setSelectionPaymentMethod={setSelectionPaymentMethod}
              courseData={selectionCourse}
              representativeData={formStateRepresentative}
              studentData={formStateStudent}
              reference={reference}
              setReference={setReference}
            />
          </Box>
        </>
      )}

      {/* Botones de navegación */}
      <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
        <Button
          variant="outlined"
          onClick={handlePreviousStep}
          disabled={step === 1}
        >
          Anterior
        </Button>
        <Button variant="contained" onClick={handleNextStep} disabled={loading}>
          {step === 1 ? (
            "Siguiente"
          ) : loading ? (
            <CircularProgress size={24} />
          ) : (
            "Confirmar"
          )}
        </Button>
      </Box>

      {/* Muestra de error */}
      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
    </Box>
  );
};

export default CreateStudentPublic;
